import * as React from 'react';
import BlackFridayAnimation from '~/customization/BlackFriday/Category/BlackFridayAnimation';

interface IBlackFriday {
    categoryName: ICategoryList;
    children: React.ReactNode;
}

const BlackFriday = ({ categoryName, children }: IBlackFriday) => {
    return (
        <React.Fragment>
            {children}
            <BlackFridayAnimation categoryName={categoryName} />
        </React.Fragment>
    );
};

export default BlackFriday;
